/*
  QuestionsAnswers_v1.js propTypes
*/
import { string } from 'prop-types'

export default {
  famNumber: string,
  pzn: string,
  question: string,
  answer: string,
  productName: string,
  seoName: string,
  personAsking: string,
  personAnswering: string,
  catId: string,
  id: string,
}
